import React, { useState, useRef, useEffect, useContext } from "react";
import styles from "./Games.module.scss";
import TinySlider from "tiny-slider-react";
import SliderControls from "./SliderButton";
import { animOnSwipe } from "../utils/animation";
import { Context } from "../Store";
import { capitalize } from "../utils/helpers";

const Games = (props) => {
  const [state] = useContext(Context);

  const gamesData = props.games || state.games;
  const playersData = props.players || state.players;

  let games = gamesData
    .filter((game) => {
      if (!game.players) return false;
      const player = playersData.find((player) => player.id == game.players.split(",")[0]);
      return player;
    })
    .map((game, index) => {
      const player = playersData.find((player) => player.id == game.players.split(",")[0]);

      let playerPhoto = player.photo
        ? "data:image/jpeg;base64, " + player.photo
        : player.gender == "male"
          ? "./img/boy.png"
          : "./img/girl.png";

      let bgSrc, message;
      switch (game.game) {
        case "DEMOLITION":
          bgSrc = "./img/game-demolition-bgi.jpg";
          message = { line1: "HIGHEST", line2: "3 DART SCORE" };
          break;
        case "SHANGHAI":
          bgSrc = "./img/game-shanghai-bgi.jpg";
          message = { line1: "HIGHEST", line2: "3 DART SCORE" };
          break;
        case "QUACKSHOT":
          bgSrc = "./img/game-quackshot-bg.jpg";
          message = { line1: "MOST", line2: "DUCKS" };
          break;
        case "KILLER":
          bgSrc = "./img/game-killer-bgi.jpg";
          message = { line1: "MOST", line2: "KILLS" };
          break;
        case "SNAKESANDLADDERS":
          bgSrc = "./img/game-snakes-bg.jpg";
          message = { line1: "MOST", line2: "SNAKES" };
          break;
        case "DONKEYDERBY":
          bgSrc = "./img/game-donkey-bg.jpg";
          message = { line1: "HIGHEST", line2: "FURLONGS" };
          break;
        case "LIMBO":
          bgSrc = "./img/game-limbo-bg.jpg";
          message = { line1: "LOWEST", line2: "LIMBO" };
          break;
        default:
          break;
      }
      return (
        <div key={game.id} id={"game_" + game.id} className={styles.gamesItem}>
          <div className={styles.gamesTile}>
            <img className={styles.gameBackground} src={bgSrc} alt="" />
            <div className={`${styles.gamePlayerSizer} ${styles["game_" + game.game?.toLowerCase()]}`}>
              <img className={styles.gamePlayer} src={playerPhoto} alt="" />
            </div>
            <div className={styles.gameMessage}>
              <svg viewBox="0 0 300 135">
                <text x="50%" textAnchor="middle">
                  <tspan x="50%" dy="20" className={styles.playerName}>
                    {capitalize(player.name)}
                  </tspan>
                  <tspan x="50%" dy="50" className={styles.gameMessageText}>
                    {message?.line1}
                  </tspan>
                  <tspan x="50%" dy="36" className={styles.gameMessageText}>
                    {message?.line2}
                  </tspan>
                </text>
              </svg>
            </div>
          </div>
        </div>
      );
    });

  let gamesMedia = gamesData
    .filter((game) => {
      if (!game.players) return false;

      const player = playersData.find((player) => player.id == game.players.split(",")[0]);
      return player;
    })
    .map((game) => {
      const player = playersData.find((player) => player.id == game.players.split(",")[0]);
      let message;
      switch (game.game) {
        case "DEMOLITION":
          message = "HIGHEST 3 DART SCORE";
          break;
        case "SHANGHAI":
          message = "HIGHEST 3 DART SCORE";
          break;
        case "QUACKSHOT":
          message = "MOST DUCKS";
          break;
        case "KILLER":
          message = "MOST KILLS";
          break;
        case "SNAKESANDLADDERS":
          message = "MOST SNAKES";
          break;
        case "DONKEYDERBY":
          message = "HIGHEST FURLONGS";
          break;
        case "LIMBO":
          message = "LOWEST LIMBO";
          break;
        default:
          break;
      }
      let gameData = JSON.stringify({
        guid: state.guid,
        gametype: game.game,
        message: message,
        playername: player.name,
        playerphoto: player.photo,
        playergender: player.gender,
      });

      return {
        mediaType: "GAME",
        mediaURI: state.guid + "_" + game.game,
        gameData: gameData,
        sectionName: "Games",
      };
    });

  const sliderRef = useRef();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFirst, setIsFirst] = useState(true);
  const [isLast, setIsLast] = useState(false);

  const settings = {
    lazyload: true,
    touch: true,
    nav: false,
    controlsContainer: "." + styles.sliderContainer + " .sliderControls",
    mouseDrag: true,
    loop: false,
    items: 1,
    gutter: 10,
    responsive: {
      640: {
        items: Math.min(games.length, 2),
        gutter: 12,
        slideBy: "page",
      },
      1024: {
        items: Math.min(games.length, 3),
        gutter: 16,
        slideBy: "page",
      },
      1440: {
        items: Math.min(games.length, 4),
        gutter: 20,
        slideBy: "page",
      },
    },
  };

  useEffect(() => {
    if (games.length > 0) {
      const slider = sliderRef.current?.slider;
      if (!slider) return;
      animOnSwipe(slider);

      const applyFinalScale = (info) => {
        setCurrentIndex(info.index);
        const allVisible = info.items >= info.slideCount;
        setIsFirst(allVisible || info.index === 0);
        setIsLast(allVisible || info.index + info.items >= info.slideCount);
        requestAnimationFrame(() => {
          const isMobileView = window.innerWidth < 640;
          const items = info.slideItems;
          for (let i = 0; i < items.length; i++) {
            if (!isMobileView) {
              items[i].style.transform = "scale(1)";
            } else if (items[i].classList.contains("tns-slide-active")) {
              items[i].style.transform = "scale(1)";
            } else {
              items[i].style.transform = "scale(0.8)";
            }
          }
        });
      };

      applyFinalScale(slider.getInfo());
      slider.events.on("indexChanged", applyFinalScale);
      return () => slider.events.off("indexChanged", applyFinalScale);
    }
  });

  if (games.length > 0) {
    return (
      <div className={`section scale-slider games_section ${styles.gamesSection}`}>
        <h3>Talking points</h3>
        <h2>Game Achievements</h2>
        <div className={styles.sliderContainer}>
          <SliderControls slider={sliderRef} dimFirst={isFirst} dimLast={isLast} variant="gold"></SliderControls>

          <TinySlider settings={settings} ref={sliderRef}>
            {games}
          </TinySlider>
        </div>
        <div className={styles.slideCounter}>
          <span>{currentIndex + 1}</span>/{games.length}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default Games;
